<script lang="ts" setup>
import { VehicleFeatures } from '@dh-io-owpi/vehicle-features/src/lib';
import { useVehicleStore } from '@/stores/vehicle';
import { useFeaturesStore } from '@/stores/features';
import { usePageStateStore } from '@/stores/pageState';
import SPASection from '@/components/SPASection.vue';

const vehicle = useVehicleStore();
const featuresStore = useFeaturesStore();
const pageState = usePageStateStore();
</script>

<template>
  <SPASection name="features" title>
    <VehicleFeatures
      analyticsSectionName="features"
      :vehicleFeaturesData="featuresStore.vehicleFeaturesData"
      :selectedStyle="pageState.style"
      :modelName="vehicle.vehicle.modelName"
    />
  </SPASection>
</template>
